import { z } from 'zod';

/**
 * C4 — schemas Zod do resumo do portal (`GET /companies/{companyId}/portal-summary`).
 *
 * Fonte: handoff `Docs/V2/Clinica/evidencias/portal-v2-local/backend-contract.md` + OpenAPI 1.45.0.
 * O `kind` da pendência é string no contrato (o servidor emite os cinco códigos documentados e
 * pode evoluir aditivamente); o cliente nunca ramifica comportamento pelo `kind` — rótulo, rota e
 * CTA já vêm prontos do servidor. `severity` é enum fechado com mapa exaustivo na apresentação.
 */

export const PortalPendingSchema = z.object({
  kind: z.string().min(1),
  severity: z.enum(['ERROR', 'WARNING', 'INFO']),
  title: z.string().min(1),
  ctaLabel: z.string().min(1),
  route: z.string().min(1),
});

export const PortalBadgesSchema = z.object({
  maintenances: z.number().int().nonnegative(),
  plan: z.number().int().nonnegative(),
  clinic: z.number().int().nonnegative(),
});

export const PortalSummarySchema = z.object({
  generatedAt: z.string().min(1),
  pendings: z.array(PortalPendingSchema).default([]),
  badges: PortalBadgesSchema,
});

export type PortalPending = z.infer<typeof PortalPendingSchema>;
export type PortalSummary = z.infer<typeof PortalSummarySchema>;
